<template>
    <div class="page_footer flex-col">
        <div class="group_footer flex-col">
            <div class="section_85 flex-col">
                <div class="text-group_374 flex-col justify-between">
                    <span class="text_361">为您打造业务风控与合规管理的专业定制化咨询服务方案</span>
                    <span class="text_362">助力企业实现可持续发展</span>
                </div>

                <div class="image-text_275 flex-row justify-between">
                    <img
                            class="label_33"
                            referrerpolicy="no-referrer"
                            src="../../assets/footer/chpc_footer_call.png"
                    />
                    <span class="text-group_375">010-58204887</span>
                </div>
                <div class="text-wrapper_135 flex-col"><span class="text_363">联系我们</span></div>

                <div class="list_29 flex-row">
                    <div
                            class="image-text_276 flex-row"
                            v-for="(item, index) in loopData2"
                            :key="index"
                    >
                        <!-- 图标 -->
                        <img
                                v-if="item.slot1 === 1"
                                class="thumbnail_15"
                                :src="item.specialSlot1.lanhuimage0"
                        />
                        <!-- 固定标签 -->
                        <span class="input-label">{{ item.lanhutext0 }}</span>
                        <!-- 输入框 -->
                        <input
                                class="form-input"
                                v-model="formData[item.field]"
                        />
                    </div>
                </div>

                <div class="text-wrapper_136 flex-col">
                  <textarea
                          class="message-input"
                          v-model="formData.content"
                          placeholder="在此留言（最多100字）"
                          maxlength="100"
                  ></textarea>
                </div>
                <div
                        class="text-wrapper_137 flex-col"
                        @click="submitForm"
                >
                    <span class="text_365">提交咨询</span>
                </div>

            </div>
            <img
                    class="image_65"
                    referrerpolicy="no-referrer"
                    src="../../assets/footer/chpc_footer_line01.png"
            />

            <div class="section_86 flex-row">

                <div class="block_98 flex-col">

                    <div class="text-wrapper_138 flex-row justify-between">
                        <div class="city-tab" @click="switchCity('beijing')">
                            <span :class="currentCity === 'beijing' ? 'text_366' : 'text_367'">北京</span>
                            <img
                                    v-show="currentCity === 'beijing'"
                                    class="image_66"
                                    src="../../assets/footer/chpc_footer_line02.png"
                            />
                        </div>
                        <div class="city-tab" @click="switchCity('shanghai')">
                            <span :class="currentCity === 'shanghai' ? 'text_366' : 'text_367'">上海</span>
                            <img
                                    v-show="currentCity === 'shanghai'"
                                    class="image_66"
                                    src="../../assets/footer/chpc_footer_line02.png"
                            />
                        </div>
                    </div>

                    <span class="text_368">电话：{{ cityInfo[currentCity].phone }}</span>
                    <span class="text_369" v-if="cityInfo[currentCity].fax">传真：{{ cityInfo[currentCity].fax }}</span>
                    <div class="text-wrapper_139 flex-row justify-between">
                        <span class="text_370">地址：</span>
                        <span class="paragraph_24">{{ cityInfo[currentCity].address }}</span>
                    </div>
                </div>



                <div class="block_99 flex-col">
                    <div class="text-wrapper_140 flex-row">
                        <span class="text_371" @click="handleMenuClick('about')">走进康柏</span>
                        <span class="text_372" @click="handleMenuClick('Advisory')">核心业务</span>
                        <span class="text_372" @click="handleMenuClick('Information')">新闻中心</span>
                        <span class="text_372" @click="handleMenuClick('contact')">联系我们</span>
                    </div>
                    <div class="list_30 flex-row">
                        <div class="text-wrapper_141 flex-col" v-for="(item, index) in loopData3" :key="index">
              <span class="text_375"
                    @click="handleMenuClick(item.href1)"
                    v-html="item.lanhutext0"></span>
                            <span class="text_376"
                                  @click="handleMenuClick(item.href2)"
                                  v-html="item.lanhutext1"></span>
                        </div>
                    </div>
                    <div class="text-wrapper_142 flex-row justify-between">
                        <span class="text_375" @click="handleMenuClick('about#value-section')">行业价值</span>
                        <span class="text_375" @click="handleMenuClick('consultation')">企业健康咨询</span>
                    </div>
                    <span class="text_379" @click="handleMenuClick('about#server-section')">服务优势</span>
                </div>
                <div class="image-text_277 flex-col justify-between">
                    <img
                            class="image_67"
                            referrerpolicy="no-referrer"
                            src="../../assets/footer/chpc_footer_gzh.png"
                    />
                    <div class="text-group_377 flex-col">
                        <span class="text_380">官⽅微信公众号</span>
                        <span class="text_381">关注康柏汉森</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="text-wrapper_143 flex-col">
          <span class="text_382">
            版权所有©北京康柏汉森医药科技咨询有限责任公司&nbsp;京ICP备01020304号&nbsp;技术支持：技术支持部
          </span>
        </div>
    </div>
</template>
<script>
    import {isNull, validateEmail} from "../../common/testFun";

    export default {
        data() {
            return {
                currentCity: 'beijing',
                cityInfo: {
                    beijing: {
                        phone: '010-58204887',
                        fax: '010-58204839',
                        address: `北京市朝阳区建国路93号院万达广场8号楼2606室
          Room 2606,Block 8,Wanda Plaza,No.93 Jianguo Road,Chaoyang District,Beijing 100022,P.R.China`
                    },
                    shanghai: {
                        phone: '021-63331086',

                        address: `上海市黄浦区蒙自路757号平安滨江金融中心30层3001室
          Suite 3001, 30/F, Ping An Binjiang Financial Center, No. 757 Mengzi Road, Huangpu District, Shanghai 200023, P.R.China`
                    }
                },
                formData: {
                    name: '',
                    company: '',
                    phone: '',
                    email: '',
                    content: ''
                },

                loopData2: [
                    {
                        field: 'name',
                        lanhuBg0:
                            'url(../../assets/common/chpc_footer_01.png) 100% no-repeat',
                        lanhutext0: '姓名',
                        specialSlot1: {
                            lanhuimage0:require('../../assets/footer/chpc_footer_wjx.png')
                        },
                        slot1: 1
                    },
                    {
                        field: 'company',
                        lanhuBg0:
                            'url(../../assets/common/chpc_footer_01.png) 0px 0px no-repeat',
                        lanhutext0: '公司',
                        specialSlot1: {
                            lanhuimage0:require('../../assets/footer/chpc_footer_wjx.png')

                        },
                        slot1: 1
                    },
                    {
                        field: 'phone',
                        lanhuBg0:
                            'url(../../assets/common/chpc_footer_01.png) -1px 0px no-repeat',
                        lanhutext0: '电话',
                        specialSlot1: {
                            lanhuimage0:require('../../assets/footer/chpc_footer_wjx.png')

                        },
                        slot1: 1
                    },
                    {
                        field: 'email',
                        lanhuBg0:
                            'url(../../assets/common/chpc_footer_01.png) 100% no-repeat',
                        lanhutext0: '邮箱'
                    }
                ],
                loopData3: [
                    { lanhutext0: '关于我们', lanhutext1: '企业荣誉', href1:'about#introduce-section',href2:'about#honor-section'},
                    { lanhutext0: '渠道风控管理', lanhutext1: '业务合规管理',href1:'Advisory',href2:'compliance' },
                    { lanhutext0: '康柏动态', lanhutext1: '行业观察', href1:'dynamics',href2:'observation',specialSlot1: { lanhutext0: '新闻中心' }, slot1: 1 },
                    { lanhutext0: '联系我们', lanhutext1: '加入我们',href1:'contact',href2:'join', specialSlot1: { lanhutext0: '联系我们' }, slot1: 1 }
                ],
                constants: {}
            };
        },
        methods: {
            resetForm() {
                this.$set(this, 'formData', {
                    name: '',
                    company: '',
                    phone: '',
                    email: '',
                    content: ''
                });
            },
            scrollToAnchor(anchor) {
                const element = document.getElementById(anchor);
                if (element) {
                    // 使用 scrollIntoView 平滑滚动到目标元素
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            },
            switchCity(city) {
                this.currentCity = city;
            },
            // 新增点击处理方法
            handleMenuClick(menuName) {
                if(isNull(menuName)){
                    return;
                }
                this.goto(menuName)
            },
            goto(url){
                url = '/' + url;
                if (url.includes('#')) {
                    let check = url.split('#')[0];
                    if (this.$route.path === check){
                        this.scrollToAnchor(url.split('#')[1]);
                    }else{
                        this.$router.push(url).then(() => {
                            this.scrollToAnchor(url.split('#')[1]);
                        });
                    }

                } else {
                    if (this.$route.path !== url){
                        this.$router.push(`${url}`).then(() => {
                            window.scrollTo(0, 0);
                        });
                    }else{
                        window.scrollTo(0, 0);
                    }
                }
            },
            submitForm() {
                console.log('提交表单数据:', this.formData);
                if(isNull(this.formData.name)){
                    this.$message.warning('请输入姓名');
                    return;
                }
                if(isNull(this.formData.company)){
                    this.$message.warning('请输入公司名称');
                    return;
                }
                if(isNull(this.formData.phone)){
                    this.$message.warning('请输入电话');
                    return;
                }
                if(!isNull(this.formData.email)){
                    if(this.formData === ' '){
                        console.log("null")
                    }else{
                        let isok = validateEmail(this.formData.email)
                        if(!isok){
                            this.$message.warning('邮箱格式不正确');
                            return;
                        }
                    }

                }
                let data = this.formData;
                let that = this;
                this.$HTTP.addConsult(data).then(resp => {
                    if(resp.code == 200){
                        this.resetForm();
                        that.$message.success("信息已提交成功!")
                    }
                });

            },
        }
    };
</script>

<style scoped lang="css"  >

    .section_85 {
        height: 656px;
        background-size: 100% 100%;

        width: 100%; /* 修改为100%宽度 */
        background: url(../../assets/footer/chpc_footer_bg_01.png) center/cover; /* 背景居中 */
        display: flex;
        flex-direction: column;
        align-items: center; /* 新增居中属性 */
    }
    .section_85.flex-row {
        display: flex;
        flex-direction: row;
    }
    .text-group_374 {
        width: 900px;
        height: 98px;
        /*margin: 100px 0 0 284px;*/
        margin: 100px auto 0;
    }
    .justify-between {
        display: flex;
        justify-content: space-between;
    }

    .flex-col {
        display: flex;
        flex-direction: column;
    }

    .text_361 {
        width: 900px;
        height: 50px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 36px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: center;
        white-space: nowrap;
        line-height: 50px;
    }

    .text_362 {
        width: 900px;
        height: 28px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 20px;
        text-align: center;
        white-space: nowrap;
        line-height: 28px;
        margin: 20px 0 0 0;
    }

    .image-text_275 {
        width: 199px;
        height: 36px;
        margin: 20px auto 0; /* 居中处理 */
    }

    .label_33 {
        width: 36px;
        height: 36px;
    }

    .text-group_375 {
        width: 157px;
        height: 28px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 24px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 700;
        text-align: left;
        white-space: nowrap;
        line-height: 29px;
        margin-top: 4px;
    }

    .text-wrapper_135 {
        background-color: rgba(255, 255, 255, 1);
        border-radius: 10px;
        height: 54px;
        width: 174px;
        margin: 20px auto 0; /* 居中处理 */
    }
    .flex-col {
        display: flex;
        flex-direction: column;
    }

    .text_363 {
        width: 80px;
        height: 28px;
        overflow-wrap: break-word;
        color: rgba(0, 134, 131, 1);
        font-size: 20px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 28px;
        margin: 13px 0 0 47px;
    }

    .list_29 {
        width: 1110px;
        height: 47px;
        justify-content: space-between;
        margin: 47px auto 0;
        gap: 10px;
    }
    .flex-row {
        display: flex;
        flex-direction: row;
    }

    .text-wrapper_136 {
        height: 105px;
        background: url(../../assets/footer/chpc_footer_input_01.png) 100% no-repeat;
        background-size: 100% 100%;
        width: 1110px;
        margin: 16px auto 0;
        box-sizing: border-box; /* 新增盒模型计算 */
        padding: 10px; /* 匹配输入框的内边距 */
    }

    .city-tab {
        position: relative;  /* 添加相对定位 */
        display: flex;
        flex-direction: column;
        align-items: center;
        cursor: pointer;
    }

    /* 修改下划线样式 */
    .image_66 {
        position: absolute;
        bottom: -20px;  /* 调整定位到文字下方 */
        left: 50%;
        transform: translateX(-50%);
        width: 32px;
        height: 2px;
        transition: all 0.3s ease;
    }

    /* 调整文字和下划线的整体布局 */
    .text-wrapper_138 {
        position: relative;
        padding-bottom: 15px;  /* 为下划线留出空间 */
    }


    /* 修改后的样式 */
    .input-label {
        position: relative; /* 改为相对定位 */
        color: #999;
        font-size: 16px;
        margin-right: 10px; /* 添加右侧间距 */
        white-space: nowrap; /* 防止换行 */
        padding-left: 10px; /* 给图标留空间 */
    }

    .form-input {
        flex: 1; /* 自动填充剩余空间 */
        border: none;
        outline: none;
        background: transparent;
        color: #333;
        font-size: 16px;
        /*padding-left: 0; /* 移除左侧内边距 */
        width: 100%;
        padding: 0 15px;
    }

    /* 调整整体布局 */
    .image-text_276 {
        flex: 1; /* 改为弹性填充 */
        min-width: 0; /* 允许内容收缩 */

        position: relative;
        width: 25%;
        height: 47px;
        background: url(../../assets/common/chpc_footer_01.png) no-repeat;
        display: flex;
        align-items: center;
        padding: 0 15px; /* 整体内边距 */
        background-size: cover; /* 新增背景适配 */
    }

    /* 图标定位调整 */
    .thumbnail_15 {
        position: absolute;
        left: 10px;
        top: 50%;
        transform: translateY(-50%);
        width: 8px;
        height: 8px;
    }

    .message-input {
        width: 100%;
        height: 100%;
        border: none;
        outline: none;
        background: transparent;
        resize: none;
        padding: 0 5px;
        color: #999;
        font-size: 16px;
        box-sizing: border-box;
    }


    .text-wrapper_137 {
        cursor: pointer;
        border-radius: 10px;
        height: 54px;
        border: 2px solid rgba(255, 255, 255, 1);
        width: 174px;
        /* 修改margin实现左对齐 */
        margin: 20px 0 39px calc((100% - 1110px)/2);
        align-self: flex-start; /* 覆盖父容器居中设置 */
        transition: all 0.3s ease;
    }
    /* 添加hover状态下的样式 */
    .text-wrapper_137:hover {
        background: rgba(255, 255, 255, 0.8); /* 半透明白色背景 */
        border-color: #008683; /* 边框颜色改为品牌绿色 */
    }

    /* 修改文字hover效果 */
    .text-wrapper_137:hover .text_365 {
        color: #008683; /* 文字颜色改为品牌绿色 */
    }

    .text_365 {
        width: 80px;
        height: 28px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 20px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 28px;
        margin: 13px 0 0 47px;
    }

    .image_65 {
        width: 1468px;
        height: 1px;
    }

    .section_86 {
        background: url(../../assets/footer/chpc_footer_input_02.png) 100% no-repeat;
        background-size: 100% 100%;
        margin-bottom: 1px;
        width: 100%; /* 修改为100%宽度 */
        height: 212px;

        display: flex;
        justify-content: center;
        /*padding: 0 20px; */
    }

    .block_98 {
        width: 395px;
        height: 162px;
        margin: 22px 0 0 189px;

    }

    .text-wrapper_138 {
        width: 91px;
        height: 23px;
        margin-left: 1px;
    }

    .text_366 {
        width: 33px;
        height: 23px;
        overflow-wrap: break-word;
        color: rgba(0, 134, 131, 1);
        font-size: 16px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: right;
        white-space: nowrap;
        line-height: 23px;
    }


    .text_367 {
        width: 33px;
        height: 23px;
        overflow-wrap: break-word;
        color: rgba(102, 104, 108, 1);
        font-size: 16px;
        font-weight: NaN;
        text-align: right;
        white-space: nowrap;
        line-height: 23px;

        transition: color 0.3s ease;
    }

    .text_368 {
        width: 140px;
        height: 20px;
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 14px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        text-align: left;
        white-space: nowrap;
        line-height: 20px;
        margin: 13px 0 0 1px;
    }

    .text_369 {
        width: 141px;
        height: 20px;
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 14px;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 20px;
        margin: 7px 0 0 1px;
    }

    .text-wrapper_139 {
        width: 395px;
        height: 60px;
        margin-top: 7px;
    }

    .text_370 {
        width: 43px;
        height: 20px;
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 14px;
        text-align: left;
        white-space: nowrap;
        line-height: 20px;
    }

    .paragraph_24 {
        width: 395px;
        height: 60px;
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 14px;

        text-align: left;
        line-height: 20px;
    }

    .block_99 {
        width: 521px;
        height: 131px;
        margin: 26px 0 0 78px;
    }

    .text-wrapper_140 {
        width: 520px;
        height: 25px;
        margin-left: 1px;
    }

    .text_371 {
        width: 73px;
        height: 25px;
        overflow-wrap: break-word;
        color: rgba(37, 37, 37, 1);
        font-size: 18px;
        letter-spacing: 0.09179999679327011px;
        font-family: AlibabaPuHuiTi_3_65_Medium;
        font-weight: 500;
        text-align: left;
        white-space: nowrap;
        line-height: 25px;
    }

    .text_372 {
        width: 73px;
        height: 25px;
        overflow-wrap: break-word;
        color: rgba(37, 37, 37, 1);
        font-size: 18px;
        letter-spacing: 0.09179999679327011px;
        font-family: AlibabaPuHuiTi_3_65_Medium;
        font-weight: 500;
        text-align: left;
        white-space: nowrap;
        line-height: 25px;
        margin-left: 67px;
    }


    .list_30 {
        width: 504px;
        height: 45px;
        margin-top: 11px;
    }

    .text-wrapper_141 {
        position: relative;
        width: 56px;
        height: 45px;
        margin-right: 85px;
    }

    /* 新增hover样式 */
    .text_371:hover,
    .text_372:hover,
    .text_375:hover,
    .text_376:hover,
    .text_379:hover {
        color: #008683 !important;
        cursor: pointer;
        transition: color 0.3s ease;
    }

    .text_375 {
        width: 84px;
        height: 20px;
        overflow-wrap: break-word;
        color: rgba(102, 104, 108, 1);
        font-size: 14px;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 20px;
    }

    .text_376 {
        width: 84px;
        height: 20px;
        overflow-wrap: break-word;
        color: rgba(102, 104, 108, 1);
        font-size: 14px;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 20px;
        margin-top: 5px;
    }

    .text-wrapper_142 {
        width: 225px;
        height: 20px;
        margin-top: 5px;
    }


    .text_379 {
        width: 56px;
        height: 20px;
        overflow-wrap: break-word;
        color: rgba(102, 104, 108, 1);
        font-size: 14px;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 20px;
        margin-top: 5px;
    }

    .image-text_277 {
        width: 100px;
        height: 140px;
        margin: 26px 134px 0 79px;
    }

    .image_67 {
        width: 100px;
        height: 100px;
    }

    .text-group_377 {
        position: relative;
        width: 84px;
        height: 33px;
        margin: 7px 0 0 9px;
    }

    .text_380 {
        width: 84px;
        height: 17px;
        overflow-wrap: break-word;
        color: rgba(102, 104, 108, 1);
        font-size: 12px;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 17px;
        margin-top: 16px;
    }

    .text_381 {
        position: absolute;
        left: 6px;
        top: 0;
        width: 72px;
        height: 17px;
        overflow-wrap: break-word;
        color: rgba(102, 104, 108, 1);
        font-size: 12px;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 17px;
    }

    .text-wrapper_143 {
        height: 60px;
        background: url(../../assets/footer/chpc_footer_input_03.png) 0px 0px no-repeat;
        margin: -1px 0 1px 0;
        width: 100%; /* 修改为100%宽度 */
        background-size: cover;
    }
    .text_382 {
        width: 750px;
        height: 20px;
        overflow-wrap: break-word;
        color: rgba(102, 104, 108, 1);
        font-size: 14px;
        text-align: center;
        white-space: nowrap;
        line-height: 20px;

        margin: 19px auto 0; /* 居中处理 */
        max-width: 100%; /* 防止溢出 */
    }

</style>
